import React from "react"
import Icon from "../../Icon/Icon"
import {JwksInfoModal} from "../JwksInfoModal/JwksInfoModal"
import {useModal} from "react-modal-hook"
import Button from "../../Button/Button"
import {JWTProviders} from "../../../resources/orgSettings"
import * as Yup from "yup"
import TextField from "../TextField/TextField"

const jwksPathSchema = Yup.string()
	.required("JWKS path is required")
	.matches(
		/^https:\/\/([A-Za-z0-9\-]+\.){2,}amazonaws\.com\/([A-Za-z0-9\-\._]+)\/\.well-known\/jwks\.json$/,
		"Must be a valid Cognito JWKS URL: 'https://cognito-idp.Region.amazonaws.com/Your_user_pool_ID/.well-known/jwks.json'"
	)

export default function CognitoFields() {
	const [showJwksInfoModal, hideJwksInfoModal] = useModal(() => (
		<JwksInfoModal close={hideJwksInfoModal} provider={JWTProviders.Cognito} />
	))

	return (
		<fieldset className="fields">
			<TextField
				name="jwksPath"
				label="JWKS Path"
				placeholder="Your JWKS Key"
				validationSchema={jwksPathSchema}
				helpElements={
					<>
						<Icon
							icon="information-circle--interface-essential"
							size={12}
							data-tip="React-tooltip"
							data-for="jwks-path-tooltip"
						/>
						<Button type="button" className="jwks-button" onClick={showJwksInfoModal}>
							How to find my JWKS
						</Button>
					</>
				}
			/>
		</fieldset>
	)
}
